import React from 'react'

export default function Countries() {
    return (
        <>
            <option value="-"></option>
            <option value="1-Afghanistan">afghanistan</option>,
            <option value="2-Albania">albania</option>,
            <option value="3-Algeria">algeria</option>,
            <option value="4-American Samoa">american samoa</option>,
            <option value="5-Andorra">andorra</option>,
            <option value="6-Angola">angola</option>,
            <option value="7-Anguilla">anguilla</option>,
            <option value="8-Antigua and Barbuda">antigua and barbuda</option>,
            <option value="9-Argentina">argentina</option>,
            <option value="10-Armenia">armenia</option>,
            <option value="11-Aruba">aruba</option>,
            <option value="12-Australia">australia</option>,
            <option value="13-Austria">austria</option>,
            <option value="14-Azerbaijan">azerbaijan</option>,
            <option value="15-Bahamas">bahamas</option>,
            <option value="16-Bahrain">bahrain</option>,
            <option value="17-Bangladesh">bangladesh</option>,
            <option value="18-Barbados">barbados</option>,
            <option value="19-Belarus">belarus</option>,
            <option value="20-Belgium">belgium</option>,
            <option value="21-Belize">belize</option>,
            <option value="22-Benin">benin</option>,
            <option value="23-Bermuda">bermuda</option>,
            <option value="24-Bhutan">bhutan</option>,
            <option value="25-Bolivia">bolivia</option>,
            <option value="26-Bosnia and Herzegovina">bosnia and herzegovina</option>,
            <option value="27-Botswana">botswana</option>,
            <option value="28-Brazil">brazil</option>,
            <option value="29-Bulgaria">bulgaria</option>,
            <option value="30-Burkina Faso">burkina faso</option>,
            <option value="31-Burundi">burundi</option>,
            <option value="32-Cambodia">cambodia</option>,
            <option value="33-Cameroon">cameroon</option>,
            <option value="34-Canada">canada</option>,
            <option value="35-Cape Verde">cape verde</option>,
            <option value="36-Cayman Islands">cayman islands</option>,
            <option value="37-Central African Republic">central african republic</option>,
            <option value="38-Chad">chad</option>,
            <option value="39-Chile">chile</option>,
            <option value="40-China">china</option>,
            <option value="41-Christmas Island (Australia)">christmas island (australia)</option>,
            <option value="42-Colombia">colombia</option>,
            <option value="43-Comoros">comoros</option>,
            <option value="44-Congo">congo</option>,
            <option value="45-Congo, the Democratic Republic of the">congo, the democratic republic of the</option>,
            <option value="46-Cook Islands">cook islands</option>,
            <option value="47-Costa Rica">costa rica</option>,
            <option value="48-Cote D'Ivoire">cote d'ivoire</option>,
            <option value="49-Croatia">croatia</option>,
            <option value="50-Cuba">cuba</option>,
            <option value="51-Cyprus">cyprus</option>,
            <option value="52-Czech Republic">czech republic</option>,
            <option value="53-Denmark">denmark</option>,
            <option value="54-Djibouti">djibouti</option>,
            <option value="55-Dominica">dominica</option>,
            <option value="56-Dominican Republic">dominican republic</option>,
            <option value="57-Ecuador">ecuador</option>,
            <option value="58-Egypt">egypt</option>,
            <option value="59-El Salvador">el salvador</option>,
            <option value="60-Eritrea">eritrea</option>,
            <option value="61-Estonia">estonia</option>,
            <option value="62-Ethiopia">ethiopia</option>,
            <option value="63-Falkland Islands (Malvinas)">falkland islands (malvinas)</option>,
            <option value="64-Faroe Islands">faroe islands</option>,
            <option value="65-Fiji">fiji</option>,
            <option value="66-Finland">finland</option>,
            <option value="67-France">france</option>,
            <option value="68-Gabon">gabon</option>,
            <option value="69-Gambia">gambia</option>,
            <option value="70-Georgia">georgia</option>,
            <option value="71-Germany">germany</option>,
            <option value="72-Ghana">ghana</option>,
            <option value="73-Gibraltar">gibraltar</option>,
            <option value="74-Greece">greece</option>,
            <option value="75-Greenland">greenland</option>,
            <option value="76-Grenada">grenada</option>,
            <option value="77-Guadeloupe">guadeloupe</option>,
            <option value="78-Guam">guam</option>,
            <option value="79-Guatemala">guatemala</option>,
            <option value="80-Guinea">guinea</option>,
            <option value="81-Guinea-Bissau">guinea-bissau</option>,
            <option value="82-Guyana (British)">guyana (british)</option>,
            <option value="83-Guyana (French)">guyana (french)</option>,
            <option value="84-Haiti">haiti</option>,
            <option value="85-Holy See (Vatican City State)">holy see (vatican city state)</option>,
            <option value="86-Honduras">honduras</option>,
            <option value="87-Hong Kong">hong kong</option>,
            <option value="88-Hungary">hungary</option>,
            <option value="89-Iceland">iceland</option>,
            <option value="90-India">india</option>,
            <option value="91-Indonesia">indonesia</option>,
            <option value="92-Iran, Islamic Republic of">iran, islamic republic of</option>,
            <option value="93-Iraq">iraq</option>,
            <option value="94-Ireland, Republic Of">ireland, republic of</option>,
            <option value="95-Israel">israel</option>,
            <option value="96-Italy">italy</option>,
            <option value="97-Jamaica">jamaica</option>,
            <option value="98-Japan">japan</option>,
            <option value="99-Jordan">jordan</option>,
            <option value="100-Kazakhstan">kazakhstan</option>,
            <option value="101-Kenya">kenya</option>,
            <option value="102-Kiribati">kiribati</option>,
            <option value="103-Korea, Democratic People's Republic of">korea, democratic people's republic of</option>,
            <option value="104-Korea, Republic of">korea, republic of</option>,
            <option value="105-Kuwait">kuwait</option>,
            <option value="106-Kyrgyzstan">kyrgyzstan</option>,
            <option value="107-Lao People's Democratic Republic">lao people's democratic republic</option>,
            <option value="108-Latvia">latvia</option>,
            <option value="109-Lebanon">lebanon</option>,
            <option value="110-Lesotho">lesotho</option>,
            <option value="111-Liberia">liberia</option>,
            <option value="112-Libya">libya</option>,
            <option value="113-Liechtenstein">liechtenstein</option>,
            <option value="114-Lithuania">lithuania</option>,
            <option value="115-Luxembourg">luxembourg</option>,
            <option value="116-Macao">macao</option>,
            <option value="117-Macedonia, Republic of">macedonia, republic of</option>,
            <option value="118-Madagascar">madagascar</option>,
            <option value="119-Malawi">malawi</option>,
            <option value="120-Malaysia">malaysia</option>,
            <option value="121-Maldives">maldives</option>,
            <option value="122-Mali">mali</option>,
            <option value="123-Malta">malta</option>,
            <option value="124-Marshall Islands">marshall islands</option>,
            <option value="125-Martinique">martinique</option>,
            <option value="126-Mauritania">mauritania</option>,
            <option value="127-Mauritius">mauritius</option>,
            <option value="128-Mayotte">mayotte</option>,
            <option value="129-Mexico">mexico</option>,
            <option value="130-Micronesia, Federated States of">micronesia, federated states of</option>,
            <option value="131-Moldova, Republic of">moldova, republic of</option>,
            <option value="132-Monaco">monaco</option>,
            <option value="133-Mongolia">mongolia</option>,
            <option value="134-Montserrat">montserrat</option>,
            <option value="135-Morocco">morocco</option>,
            <option value="136-Mozambique">mozambique</option>,
            <option value="137-Myanmar">myanmar</option>,
            <option value="138-Namibia">namibia</option>,
            <option value="139-Nauru">nauru</option>,
            <option value="140-Nepal">nepal</option>,
            <option value="141-Netherlands">netherlands</option>,
            <option value="142-Netherlands Antilles">netherlands antilles</option>,
            <option value="143-New Caledonia">new caledonia</option>,
            <option value="144-New Zealand">new zealand</option>,
            <option value="145-Nicaragua">nicaragua</option>,
            <option value="146-Niger">niger</option>,
            <option value="147-Nigeria">nigeria</option>,
            <option value="148-Niue">niue</option>,
            <option value="149-Norfolk Island">norfolk island</option>,
            <option value="150-Norway">norway</option>,
            <option value="151-Oman">oman</option>,
            <option value="152-Pakistan">pakistan</option>,
            <option value="153-Palau">palau</option>,
            <option value="154-Panama">panama</option>,
            <option value="155-Papua New Guinea">papua new guinea</option>,
            <option value="156-Paraguay">paraguay</option>,
            <option value="157-Peru">peru</option>,
            <option value="158-Philippines">philippines</option>,
            <option value="159-Poland">poland</option>,
            <option value="160-Portugal">portugal</option>,
            <option value="161-Puerto Rico">puerto rico</option>,
            <option value="162-Qatar">qatar</option>,
            <option value="163-Reunion, Island Of">reunion, island of</option>,
            <option value="164-Romania">romania</option>,
            <option value="165-Russian Federation">russian federation</option>,
            <option value="166-Rwanda">rwanda</option>,
            <option value="167-Saint Helena">saint helena</option>,
            <option value="168-Saint Kitts and Nevis">saint kitts and nevis</option>,
            <option value="169-Saint Lucia">saint lucia</option>,
            <option value="170-Saint Vincent and the Grenadines">saint vincent and the grenadines</option>,
            <option value="171-Samoa">samoa</option>,
            <option value="172-San Marino">san marino</option>,
            <option value="173-Sao Tome and Principe">sao tome and principe</option>,
            <option value="174-Saudi Arabia">saudi arabia</option>,
            <option value="175-Senegal">senegal</option>,
            <option value="176-Serbia">serbia</option>,
            <option value="177-Montenegro">montenegro</option>,
            <option value="178-Seychelles">seychelles</option>,
            <option value="179-Sierra Leone">sierra leone</option>,
            <option value="180-Singapore">singapore</option>,
            <option value="181-Slovakia">slovakia</option>,
            <option value="182-Slovenia">slovenia</option>,
            <option value="183-Solomon Islands">solomon islands</option>,
            <option value="184-Somalia">somalia</option>,
            <option value="185-South Africa">south africa</option>,
            <option value="186-Spain">spain</option>,
            <option value="187-Sri Lanka">sri lanka</option>,
            <option value="188-Sudan">sudan</option>,
            <option value="189-Suriname">suriname</option>,
            <option value="190-Swaziland">swaziland</option>,
            <option value="191-Sweden">sweden</option>,
            <option value="192-Switzerland">switzerland</option>,
            <option value="193-Syria">syria</option>,
            <option value="194-Taiwan">taiwan</option>,
            <option value="195-Tajikistan">tajikistan</option>,
            <option value="196-Tanzania">tanzania</option>,
            <option value="197-Thailand">thailand</option>,
            <option value="198-Timor-Leste">timor-leste</option>,
            <option value="199-Togo">togo</option>,
            <option value="200-Tokelau">tokelau</option>,
            <option value="201-Tonga">tonga</option>,
            <option value="202-Trinidad and Tobago">trinidad and tobago</option>,
            <option value="203-Tunisia">tunisia</option>,
            <option value="204-Turkey">turkey</option>,
            <option value="205-Turkmenistan">turkmenistan</option>,
            <option value="206-Turks and Caicos Islands">turks and caicos islands</option>,
            <option value="207-Tuvalu">tuvalu</option>,
            <option value="208-Uganda">uganda</option>,
            <option value="209-Ukraine">ukraine</option>,
            <option value="210-United Arab Emirates">united arab emirates</option>,
            <option value="211-United Kingdom">united kingdom</option>,
            <option value="212-United States">united states</option>,
            <option value="213-Uruguay">uruguay</option>,
            <option value="214-Uzbekistan">uzbekistan</option>,
            <option value="215-Vanuatu">vanuatu</option>,
            <option value="216-Venezuela">venezuela</option>,
            <option value="217-Vietnam">vietnam</option>,
            <option value="218-Virgin Islands, British">virgin islands, british</option>,
            <option value="219-Virgin Islands, U.S.">virgin islands, u.s.</option>,
            <option value="220-Yemen">yemen</option>,
            <option value="221-Zambia">zambia</option>,
            <option value="222-Zimbabwe">zimbabwe</option>
        </>
    )
}
